export const AB_TEST_ACTIVATION_VISUALIZATION = 'visualizeAbTestActivation';

export const dispatchAbTestActivationEvent = (options: {
  name: string;
  value?: string;
}) => {
  window.dispatchEvent(
    new CustomEvent(AB_TEST_ACTIVATION_VISUALIZATION, {
      detail: options,
    }),
  );
};
